export const PACKAGE_SETS = {
  STANDARD: 'standard',
  PHONE: 'phone',
};

// initial state
const state = () => ({
  packages: [],
  timer: null,
  voucher: null,
  selectedPackage: null,
  packageSet: PACKAGE_SETS.STANDARD,
  cid: null,
  ip: null,
  ips: {},
});

// getters
const getters = {
  getPackages: state => {
    return state.packages;
  },
  getTimer: state => {
    return state.timer;
  },
  getSelectedPackage: state => {
    return state.selectedPackage;
  },
  getPackageSet: state => {
    return state.packageSet;
  },
  getVoucher: state => {
    return state.voucher;
  },
  getCid: state => {
    return state.cid;
  },
  getIp: state => {
    return state.ip;
  },
  getIps: state => {
    return state.ips;
  },
};

// actions
const actions = {
  load({ commit }, { unit = 'coin', userId = '', shop = '' }) {
    const test = new URLSearchParams(window.location.search).get('test');

    return axios
      .get(zRoute('ajax.payment.shop_package.index', {
        unit: unit,
        service: 'WEB',
        shop: shop,
        user_id: userId,
        ...(test ? { test } : {}),
      }))
      .then((response) => {
        commit('setPackages', response.data.data);
        commit('setTimer', response.data.timer);
        return response.data.ip;
      })
      .catch(() => {
        return false;
      });
  },
};

// mutations
const mutations = {
  setPackages: (state, packages) => {
    state.packages = packages;
  },
  setTimer: (state, timer) => {
    state.timer = timer;
  },
  setVoucher: (state, voucher) => {
    state.voucher = voucher;
  },
  setSelectedPackage: (state, selectedPackage) => {
    state.selectedPackage = selectedPackage;
  },
  setPackageSet: (state, packageSet) => {
    state.packageSet = packageSet;
  },
  setCid: (state, cid) => {
    state.cid = cid;
  },
  setIp: (state, ip) => {
    state.ip = (ip) ? ip.trim() : '';
  },
  setIps: (state, { name, ip }) => {
    console.log('setIps1:', name, '|' + ip + '|');
    state.ips[name] = (ip) ? ip.trim() : '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
